import "slick-carousel";

export function slider() {
    $(document).ready(function(){
        $('.slider_content').slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            adaptiveHeight: true,
            prevArrow: false,
            nextArrow: false
        });
    });
}


// WEBPACK FOOTER //
// ./private/blocks/slider/slider.js